/*
 * hab-fit.js — Does my bike fit? page
 * Wraps the prototype's two IIFEs into one deferred bundle.
 * Every DOM lookup is guarded — a section that isn't rendered will no-op cleanly.
 */
(function(){
  'use strict';
  if (!document.querySelector('.hab-fit')) return;

/* ──────────────────────────────────────────────────────
   Live fit-check verdict
   ────────────────────────────────────────────────────── */
(function(){
const form  = document.getElementById('fitForm');
  if (!form) return;
  const light = document.getElementById('rLight');
  const state = document.getElementById('rState');
  const summary = document.getElementById('rSummary');
  const need  = document.getElementById('rNeed');
  const check = document.getElementById('rCheck');
  const conf  = document.getElementById('rConf');

  const A = {
    qr:   { tier:'green', label:'Quick release' },
    thru: { tier:'amber', label:'12 mm thru-axle' },
    nut:  { tier:'green', label:'Nutted' },
    igh:  { tier:'amber', label:'Internal gear hub' },
    hub:  { tier:'red',   label:'Rear hub motor' },
    unsure:{ tier:'amber', label:'Unknown axle' }
  };
  const D = {
    clean:{ tier:'green' },
    disc: { tier:'amber' },
    hood: { tier:'amber' },
    horiz:{ tier:'red'   },
    unsure:{ tier:'amber'}
  };
  const B = {
    road:'a road bike', hybrid:'a hybrid', mtb:'a mountain bike',
    gravel:'a gravel bike', ebike:'an e-bike', cargo:'a cargo bike',
    fold:'a folding bike', unsure:'your bike'
  };
  const T = {
    dog:'dog trailer', child:'child trailer', cargo:'cargo trailer',
    shop:'Andersen Shopper', unsure:'a trailer'
  };

  function worst(a,b){
    const order = {green:0, amber:1, red:2};
    return order[a] > order[b] ? a : b;
  }
  function val(name){
    const el = form.querySelector(`input[name="${name}"]:checked`);
    return el ? el.value : null;
  }
  function setList(el, items){
    el.innerHTML = items.map(i => `<li>${i}</li>`).join('');
  }

  function update(){
    const trailer = val('trailer'), bike = val('bike'), axle = val('axle'), drop = val('dropout');
    let tier = worst(A[axle].tier, D[drop].tier);
    // edge: e-bike pulls amber even on clean QR
    if (bike === 'ebike' && tier === 'green') tier = 'amber';
    // edge: shopper trailer + horiz dropout escalates to red
    if (trailer === 'shop' && drop === 'horiz') tier = 'red';

    // lamp + state line
    light.className = 'res-light ' + tier;
    const labels = {
      green:'Likely fits — standard hitch',
      amber:'Probably fits — with an adapter',
      red:'Manual check required'
    };
    state.textContent = labels[tier];

    // summary
    let s = '';
    if (tier === 'green') {
      s = `A ${A[axle].label.toLowerCase()} axle on ${B[bike]} with a clean dropout is the simplest case. Most ${T[trailer]}s clamp on out of the box.`;
    } else if (tier === 'amber') {
      const why =
        axle === 'thru' ? 'a thru-axle bike needs a trailer-rated replacement axle' :
        axle === 'igh'  ? 'hub-gear bikes need a brand-specific axle nut hitch' :
        bike === 'ebike'? 'e-bikes need a manufacturer towing approval and the right adapter' :
        drop === 'hood' ? 'hooded dropouts need a flat-plate adapter to seat the hitch' :
        drop === 'disc' ? 'a disc calliper next to the axle usually means a small spacer' :
        'one detail needs an adapter';
      s = `${B[bike].charAt(0).toUpperCase()+B[bike].slice(1)} with a ${A[axle].label.toLowerCase()} towing a ${T[trailer]} — ${why}. We carry them all.`;
    } else {
      s = `${B[bike].charAt(0).toUpperCase()+B[bike].slice(1)} with this combination needs a human eye before we recommend a trailer. Send us a photo — it's free and quick.`;
    }
    summary.textContent = s;

    // need list
    const needs = [];
    if (axle === 'qr')   needs.push('Standard hitch supplied with the trailer','Your existing 5 mm quick-release skewer');
    if (axle === 'thru') needs.push('Brand-specific thru-axle (Robert Axle Project, Burley or Croozer)','Same axle diameter, length and thread pitch as your current one');
    if (axle === 'nut')  needs.push('Standard nutted hitch','A few mm of exposed thread beyond the nut');
    if (axle === 'igh')  needs.push('Axle-nut hitch for hub-gear bikes','Confirmation the brand supports your specific hub');
    if (axle === 'hub')  needs.push('Manufacturer approval to tow','Brand-specific or custom hitch — varies wildly');
    if (axle === 'unsure') needs.push('A photo of your rear axle (we will identify it)');
    if (drop  === 'hood') needs.push('Flat-plate dropout adapter');
    if (drop  === 'horiz')needs.push('Chain tug or frame-mount hitch alternative');
    setList(need, needs);

    // check list
    const checks = [];
    checks.push('Clearance for the hitch arm to swing freely');
    if (bike === 'ebike') checks.push('Manufacturer towing approval in the e-bike manual');
    if (drop === 'disc')  checks.push('Disc calliper clears the hitch face');
    if (drop === 'hood')  checks.push('Hitch can sit flush, not on a curve');
    if (drop === 'horiz') checks.push('Axle cannot pull rearward under load');
    if (trailer === 'cargo' || trailer === 'shop') checks.push('Bike rated for the full trailer + cargo weight');
    if (bike === 'fold')  checks.push('Folded frame doesn\u2019t put trailer arm in the way');
    setList(check, checks);

    // confidence
    const map = {
      green:'High — about 8 in 10 setups like this fit on the first try.',
      amber:'Medium — fit is achievable but depends on the right adapter. Confirm before ordering.',
      red:'Low without a manual check. Don\u2019t order until we\u2019ve seen the bike.'
    };
    conf.textContent = map[tier];
  }

  form.addEventListener('change', update);
  update();
})();


/* ── Trailer lookup, ctx reveals, sticky pill, submission form ── */

/* Trailer lookup + share + sticky pill + contextual reveals + submission form */
(function(){
  /* Trailer catalogue — sourced at page-render time by the hab-fit-trailer-data
     Liquid snippet (union of active products across the 5 category collections,
     deduped by handle). Each item: { brand, model, handle, url, type, price, available }.
     We enrich with modelClean (title stripped of brand prefix), typeLabel (friendly
     category name), and profile key (see PROFILES below). */
  const TYPE_LABELS = {
    'child-bike-trailers':     'Child trailer',
    'dog-bike-trailers':       'Dog trailer',
    'cargo-bike-trailers':     'Cargo trailer',
    'shopping-bike-trailers':  'Shopping trailer',
    'trailer-cycles-tag-alongs': 'Trailer cycle / tag-along'
  };

  /* Map a vendor string → PROFILES key. Handles common vendor spelling variants
     (e.g. "Andersen-Shopper" vs "Andersen Shopper" — normalised the same way).
     Returns null for unknown brands; renderResult falls back to a "check with us"
     matrix for those. */
  function profileKeyForBrand(brand){
    if (!brand) return null;
    const norm = String(brand).toLowerCase().replace(/[^a-z]/g, '');
    if (norm === 'andersen' || norm === 'andersenshopper') return 'andersen';
    if (norm === 'dutchdog' || norm === 'dutchdogdesign' || norm === 'doggyride') return 'doggytourer';
    if (norm === 'burley')      return 'burley';
    if (norm === 'croozer')     return 'croozer';
    if (norm === 'hamax')       return 'hamax';
    if (norm === 'thule')       return 'thule';
    if (norm === 'doggytourer') return 'doggytourer';
    if (norm === 'weehoo')      return 'weehoo';
    return null;
  }

  const trailerDataEl = document.getElementById('hab-fit-trailer-data');
  let TRAILERS = [];
  if (trailerDataEl) {
    try {
      const raw = JSON.parse(trailerDataEl.textContent) || [];
      const seenHandles = new Set();
      TRAILERS = raw.filter(t => t && t.brand && t.handle && !seenHandles.has(t.handle) && seenHandles.add(t.handle))
        .map(t => {
          let model = String(t.model || '').trim();
          const bl = t.brand.toLowerCase();
          const ml = model.toLowerCase();
          if (ml.startsWith(bl + ' | ')) model = model.slice(t.brand.length + 3).trim();
          else if (ml.startsWith(bl + ' ')) model = model.slice(t.brand.length + 1).trim();
          if (!model) model = t.model;
          return Object.assign({}, t, {
            modelClean: model,
            typeLabel:  TYPE_LABELS[t.type] || t.type || '',
            profile:    profileKeyForBrand(t.brand)
          });
        });
    } catch (e) { TRAILERS = []; }
  }

  const PROFILES = {
    croozer:{
      qr:  { v:'green', note:'Fits directly with the supplied hitch.' },
      thru:{ v:'amber', note:'Croozer 12 mm thru-axle adapter (sold separately).' },
      nut: { v:'green', note:'Fits directly on nutted axles.' },
      igh: { v:'amber', note:'Croozer axle-nut hitch for hub-gear bikes.' },
      hub: { v:'amber', note:'Depends on motor — send us the model.' }
    },
    burley:{
      qr:  { v:'green', note:'Fits with the supplied Burley hitch.' },
      thru:{ v:'amber', note:'Burley Ballz thru-axle adapter (sold separately).' },
      nut: { v:'green', note:'Fits directly.' },
      igh: { v:'amber', note:'Adapter required — send hub model.' },
      hub: { v:'amber', note:'Case-by-case — ask us to check the manual.' }
    },
    'burley-cargo':{
      qr:  { v:'green', note:'Fits with the supplied Burley Coho fork mount.' },
      thru:{ v:'amber', note:'Burley Coho thru-axle adapter (sold separately).' },
      nut: { v:'amber', note:'Fits some — check with us before ordering.' },
      igh: { v:'red',   note:'Not recommended — single-wheel cargo pulls hard on the hub.' },
      hub: { v:'red',   note:'Not recommended — cargo forces vs hub motor.' }
    },
    hamax:{
      qr:  { v:'green', note:'Fits with the supplied Hamax hitch.' },
      thru:{ v:'amber', note:'Hamax 12 mm thru-axle coupling kit (sold separately).' },
      nut: { v:'green', note:'Fits directly.' },
      igh: { v:'amber', note:'Adapter available — send hub model.' },
      hub: { v:'amber', note:'Case-by-case — ask us to check the manual.' }
    },
    thule:{
      qr:  { v:'green', note:'Fits with the included Thule ezHitch.' },
      thru:{ v:'amber', note:'Thule Axle Mount ezHitch (sold separately).' },
      nut: { v:'green', note:'Fits directly.' },
      igh: { v:'amber', note:'Adapter available — check hub with us.' },
      hub: { v:'amber', note:'Ask us — Thule maintains an approved-bike list.' }
    },
    doggytourer:{
      qr:  { v:'green', note:'Fits with the supplied bracket.' },
      thru:{ v:'amber', note:'Custom axle — we source per bike.' },
      nut: { v:'green', note:'Fits directly.' },
      igh: { v:'amber', note:'Case-by-case — ask us.' },
      hub: { v:'red',   note:'Not recommended by DoggyTourer.' }
    },
    andersen:{
      qr:  { v:'green', note:'Bike Coupling clamps to the skewer.' },
      thru:{ v:'amber', note:'Andersen sell a thru-axle version of the Bike Coupling.' },
      nut: { v:'green', note:'Fits directly.' },
      igh: { v:'amber', note:'Send hub model — usually fine.' },
      hub: { v:'amber', note:'Small load, but ask us to confirm your motor.' }
    },
    weehoo:{
      qr:  { v:'green', note:'Fits standard 5 mm QR skewers.' },
      thru:{ v:'amber', note:'Robert Axle Project trailer axle required.' },
      nut: { v:'amber', note:'Check — depends on your wheel size (26" / 700c).' },
      igh: { v:'red',   note:'Not recommended for internal-gear-hub bikes.' },
      hub: { v:'red',   note:'Not recommended for rear-hub-motor bikes.' }
    }
  };

  const AXLES = [
    { key:'qr',   label:'Quick release' },
    { key:'thru', label:'12 mm thru-axle' },
    { key:'nut',  label:'Nutted / bolt-on' },
    { key:'igh',  label:'Internal gear hub' },
    { key:'hub',  label:'Rear hub motor' }
  ];

  const brandSel = document.getElementById('brandSel');
  const modelSel = document.getElementById('modelSel');
  const resultEl = document.getElementById('lookupResult');
  const countEl  = document.getElementById('lookupCount');

  /* Wave 27.4a Phase 4d — trailer-lookup block gated by brandSel existence
     instead of early-returning the whole IIFE. Prior behaviour bailed out of
     the entire submission-form binding when #brandSel wasn't rendered on the
     page — meaning the concierge form's submit button never got its click
     handler, native form POST fired without our upload chain, and photos
     never left the browser. This wraps ONLY the trailer-lookup code (which
     genuinely needs brandSel/modelSel/resultEl/countEl) so submission-form
     binding below runs unconditionally. Zero cross-region references — every
     const/function/renderResult/DEFAULT_PROFILE/etc. inside this block is
     used only by trailer-lookup. Closing brace is right before the TAB
     SWITCHING comment. */
  if (brandSel) {

  const uniq = arr => [...new Set(arr)];
  const brands = uniq(TRAILERS.map(t => t.brand)).sort((a,b) => a.localeCompare(b));

  countEl.innerHTML = 'Currently stocking <b>' + TRAILERS.length + '</b> trailers across <b>' + brands.length + '</b> brands.';

  brands.forEach(b => {
    const opt = document.createElement('option'); opt.value = b; opt.textContent = b;
    brandSel.appendChild(opt);
  });

  function resetSelect(sel, placeholder){
    sel.innerHTML = '';
    const opt = document.createElement('option'); opt.value = ''; opt.textContent = placeholder;
    sel.appendChild(opt);
  }

  brandSel.addEventListener('change', () => {
    resetSelect(modelSel, 'Select model…');
    if (!brandSel.value){ modelSel.disabled = true; renderEmpty(); updateURL(); return; }
    TRAILERS.filter(t => t.brand === brandSel.value)
      .sort((a, b) => a.modelClean.localeCompare(b.modelClean))
      .forEach(t => {
        const opt = document.createElement('option');
        opt.value = t.model; opt.textContent = t.modelClean + '  ·  ' + t.typeLabel;
        modelSel.appendChild(opt);
      });
    modelSel.disabled = false;
    renderEmpty();
    updateURL();
  });

  modelSel.addEventListener('change', () => {
    if (!modelSel.value){ renderEmpty(); updateURL(); return; }
    renderResult();
    updateURL();
  });

  function renderEmpty(){
    resultEl.innerHTML = ''
      + '<div class="lookup-empty">'
      +   '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" stroke="#F5F1E8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
      +     '<path d="M8 34 L 44 34 L 44 18 L 18 18 Z"/>'
      +     '<circle cx="20" cy="40" r="5"/>'
      +     '<circle cx="38" cy="40" r="5"/>'
      +     '<path d="M8 34 L 3 30"/>'
      +   '</svg>'
      +   '<p><b>Pick a trailer.</b>Select brand and model to see<br/>which bikes it fits + a link to the product.</p>'
      + '</div>';
  }

  function trailerIcon(){
    return '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
      +   '<path d="M7 30 L 41 30 L 41 16 L 15 16 Z"/>'
      +   '<circle cx="17" cy="36" r="4.5"/>'
      +   '<circle cx="33" cy="36" r="4.5"/>'
      +   '<path d="M7 30 L 3 27"/>'
      + '</svg>';
  }

  /* Unknown-brand fallback: every axle reads "check with us" (amber). */
  const DEFAULT_PROFILE = {
    qr:   { v:'amber', note:"Ask us — we'll confirm for this brand." },
    thru: { v:'amber', note:"Ask us — we'll confirm for this brand." },
    nut:  { v:'amber', note:"Ask us — we'll confirm for this brand." },
    igh:  { v:'amber', note:"Ask us — we'll confirm for this brand." },
    hub:  { v:'amber', note:"Ask us — we'll confirm for this brand." }
  };

  function escapeHtml(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, ch => (
      {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]
    ));
  }

  function renderResult(){
    const trailer = TRAILERS.find(t => t.brand === brandSel.value && t.model === modelSel.value);
    if (!trailer) return renderEmpty();
    const profile = (trailer.profile && PROFILES[trailer.profile]) || DEFAULT_PROFILE;

    const matrixHTML = AXLES.map(a => {
      const c = profile[a.key];
      return '<li>'
        +   '<span class="dot ' + c.v + '"></span>'
        +   '<span class="kind">' + a.label + '</span>'
        +   '<span class="note">' + escapeHtml(c.note) + '</span>'
        + '</li>';
    }).join('');

    const priceLine = trailer.price ? ('<p class="price">' + escapeHtml(trailer.price) + '</p>') : '';
    const hasPhoto = !!(trailer.image && trailer.image.length > 0);
    const altText = trailer.image_alt || (trailer.brand + ' ' + trailer.modelClean);
    const thumbBlock = hasPhoto
      ? '<a class="trailer-thumb" href="' + escapeHtml(trailer.url) + '" aria-label="View ' + escapeHtml(trailer.modelClean) + '"><img src="' + escapeHtml(trailer.image) + '" alt="' + escapeHtml(altText) + '" loading="lazy" width="320" /></a>'
      : '<div class="trailer-thumb">' + trailerIcon() + '</div>';
    const summaryClass = hasPhoto ? 'trailer-summary has-photo' : 'trailer-summary';

    resultEl.innerHTML = ''
      + '<div class="res-head">'
      +   '<p class="res-eyebrow">' + escapeHtml(trailer.brand) + (trailer.typeLabel ? ' · ' + escapeHtml(trailer.typeLabel) : '') + '</p>'
      +   '<div class="' + summaryClass + '">'
      +     thumbBlock
      +     '<div class="trailer-meta">'
      +       '<p class="name">' + escapeHtml(trailer.modelClean) + '</p>'
      +       '<a class="view-product-inline" href="' + escapeHtml(trailer.url) + '">View product<span aria-hidden="true"> →</span></a>'
      +       priceLine
      +     '</div>'
      +   '</div>'
      + '</div>'
      + '<div class="res-body">'
      +   '<div class="res-section">'
      +     '<h4>Fits these axle types</h4>'
      +     '<ul class="compat-matrix">' + matrixHTML + '</ul>'
      +   '</div>'
      + '</div>'
      + '<div class="res-foot">'
      +   '<a class="btn btn-cream" href="' + escapeHtml(trailer.url) + '">View product →</a>'
      +   '<a class="btn btn-ghost on-dark" href="#concierge">Have us double-check it →</a>'
      + '</div>';
  }

  function updateURL(){
    const params = new URLSearchParams();
    if (brandSel.value) params.set('trailer', brandSel.value);
    if (modelSel.value) params.set('model', modelSel.value);
    const q = params.toString();
    const url = location.pathname + (q ? '?' + q : '') + location.hash;
    history.replaceState(null, '', url);
  }

  /* Deep-link prefill via ?trailer=Croozer&model=Kid+Plus+for+1 */
  const params = new URLSearchParams(location.search);
  if (params.get('trailer')){
    brandSel.value = params.get('trailer');
    brandSel.dispatchEvent(new Event('change'));
    if (params.get('model')){
      const wanted = params.get('model');
      const opt = [...modelSel.options].find(o => o.value === wanted);
      if (opt){
        modelSel.value = wanted;
        modelSel.dispatchEvent(new Event('change'));
      }
    }
  } else {
    renderEmpty();
  }

  } /* end if (brandSel) — Wave 27.4a Phase 4d gate on trailer-lookup only */

  /* ================== TAB SWITCHING (merged finder) ================== */
  const tabs = document.querySelectorAll('.finder-tab');
  const panels = document.querySelectorAll('.finder-panel');
  tabs.forEach(t => t.addEventListener('click', () => {
    const key = t.dataset.tab;
    tabs.forEach(x => x.setAttribute('aria-selected', x.dataset.tab === key ? 'true' : 'false'));
    panels.forEach(p => p.classList.toggle('active', p.id === 'tab-' + key));
  }));

  /* ================== SUBMISSION FORM ================== */
  const form = document.getElementById('submissionForm');
  /* Wave 27.4 — {% form 'contact' %} has no novalidate parameter, so the
     browser's native validation UI would otherwise fire ahead of our own
     border-color validation below. Set it here instead of relying on the
     Liquid tag to emit an attribute it doesn't support. */
  if (form) form.noValidate = true;
  const photoInput = document.getElementById('photoInput');
  const photoDrop = document.getElementById('photoDrop');
  const photoPreviews = document.getElementById('photoPreviews');
  const uploaded = [];

  /* Concierge Brand → Model picker — reuses the shared TRAILERS array loaded
     at the top of this IIFE. Hidden #submitTrailerCombined preserves the
     legacy "Brand — Model" shape the submission payload used to carry. */
  const submitBrandSel = document.getElementById('submitBrand');
  const submitModelSel = document.getElementById('submitModel');
  const submitTrailerCombined = document.getElementById('submitTrailerCombined');

  if (submitBrandSel && submitModelSel && submitTrailerCombined && TRAILERS.length > 0) {
    /* Group enriched TRAILERS by brand (data already deduped by handle upstream) */
    const groups = new Map();
    TRAILERS.forEach(t => {
      if (!groups.has(t.brand)) groups.set(t.brand, []);
      groups.get(t.brand).push({ model: t.modelClean, originalTitle: t.model, handle: t.handle, url: t.url, type: t.typeLabel });
    });

    const sortedBrands = [...groups.keys()].sort((a, b) => a.localeCompare(b));
    sortedBrands.forEach(b => {
      const opt = document.createElement('option');
      opt.value = b;
      opt.textContent = b + '  (' + groups.get(b).length + ')';
      submitBrandSel.appendChild(opt);
    });

    function resetModelSel(msg){
      submitModelSel.innerHTML = '';
      const opt = document.createElement('option');
      opt.value = ''; opt.textContent = msg;
      submitModelSel.appendChild(opt);
      submitModelSel.disabled = true;
    }
    function updateCombined(){
      const b = submitBrandSel.value;
      const m = submitModelSel.value;
      if (!b) { submitTrailerCombined.value = ''; return; }
      submitTrailerCombined.value = m ? (b + ' — ' + m) : b;
    }

    submitBrandSel.addEventListener('change', () => {
      const b = submitBrandSel.value;
      if (!b) { resetModelSel('Pick a brand first'); updateCombined(); return; }
      submitModelSel.innerHTML = '';
      const opt0 = document.createElement('option');
      opt0.value = ''; opt0.textContent = 'Not sure — you tell me';
      submitModelSel.appendChild(opt0);
      (groups.get(b) || []).slice().sort((x, y) => x.model.localeCompare(y.model)).forEach(it => {
        const opt = document.createElement('option');
        opt.value = it.model; opt.textContent = it.model;
        submitModelSel.appendChild(opt);
      });
      submitModelSel.disabled = false;
      updateCombined();
    });
    submitModelSel.addEventListener('change', updateCombined);

    /* Deep-link prefill: ?trailer=Croozer&model=Kid+Plus+for+1 */
    const params = new URLSearchParams(location.search);
    const wantBrand = params.get('trailer');
    if (wantBrand && groups.has(wantBrand)) {
      submitBrandSel.value = wantBrand;
      submitBrandSel.dispatchEvent(new Event('change'));
      const wantModel = params.get('model');
      if (wantModel) {
        const opt = [...submitModelSel.options].find(o => o.value === wantModel);
        if (opt) { submitModelSel.value = wantModel; updateCombined(); }
      }
    }
  }

  function renderPreviews(){
    photoPreviews.innerHTML = '';
    uploaded.forEach((file, i) => {
      const url = URL.createObjectURL(file);
      const wrap = document.createElement('div');
      wrap.className = 'p';
      wrap.innerHTML = '<img src="' + url + '" alt=""/><button type="button" aria-label="Remove photo" data-remove="' + i + '">×</button>';
      photoPreviews.appendChild(wrap);
    });
  }

  if (photoInput) {
    photoInput.addEventListener('change', () => {
      [...photoInput.files].forEach(f => {
        if (uploaded.length < 5) uploaded.push(f);
      });
      renderPreviews();
      photoInput.value = '';
    });
  }
  if (photoDrop) {
    ['dragenter','dragover'].forEach(ev => photoDrop.addEventListener(ev, e => { e.preventDefault(); photoDrop.classList.add('dragover'); }));
    ['dragleave','drop'].forEach(ev => photoDrop.addEventListener(ev, e => { e.preventDefault(); photoDrop.classList.remove('dragover'); }));
    photoDrop.addEventListener('drop', e => {
      const files = [...(e.dataTransfer && e.dataTransfer.files || [])].filter(f => f.type.startsWith('image/'));
      files.forEach(f => {
        if (uploaded.length < 5) uploaded.push(f);
      });
      renderPreviews();
    });
  }
  if (photoPreviews) {
    photoPreviews.addEventListener('click', e => {
      const btn = e.target.closest('[data-remove]');
      if (!btn) return;
      uploaded.splice(parseInt(btn.dataset.remove, 10), 1);
      renderPreviews();
    });
  }
  /* Wave 27.4 — Cloudinary unsigned upload before the real Shopify contact
     form submit. Photos never travel in the form POST itself (Shopify's
     contact form doesn't handle file attachments) — each file goes to
     Cloudinary first, and the returned secure_urls are newline-joined into
     the hidden contact[axle_photo_urls] field before the native submit. */
  const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/tnpcvpnp/image/upload';
  const CLOUDINARY_PRESET = 'hab-hub-fit';
  const axlePhotoUrlsField = document.getElementById('axlePhotoUrls');
  const submitBtn = form ? form.querySelector('.submit-btn') : null;
  let uploadErrorEl = null;

  function showUploadError(msg){
    if (!uploadErrorEl) {
      uploadErrorEl = document.createElement('p');
      uploadErrorEl.className = 'upload-error';
      photoPreviews.insertAdjacentElement('afterend', uploadErrorEl);
    }
    uploadErrorEl.textContent = msg;
  }
  function clearUploadError(){
    if (uploadErrorEl) { uploadErrorEl.remove(); uploadErrorEl = null; }
  }

  /* Hardened Cloudinary upload: 20s timeout race guards against silent
     fetch stalls; res.ok guard converts non-2xx HTTP to a caught rejection;
     secure_url guard catches malformed responses. Rejections bubble to
     Promise.all so the submit-handler .catch can show an inline error. */
  function uploadPhoto(file){
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_PRESET);
    fd.append('folder', 'hab-fit-photos');
    var uploadFetch = fetch(CLOUDINARY_URL, { method: 'POST', body: fd }).then(function(res){
      if (!res.ok) throw new Error('cloudinary_http_' + res.status);
      return res.json();
    }).then(function(data){
      if (!data.secure_url) throw new Error('cloudinary_no_url');
      return data.secure_url;
    });
    var timeout = new Promise(function(_, reject){
      setTimeout(function(){ reject(new Error('upload_timeout_20s')); }, 20000);
    });
    return Promise.race([uploadFetch, timeout]);
  }

  /* Wave 27.4a Phase 3b — re-entry guard for the submit handler. Prevents
     a second submit (from double-click or Enter-while-uploading) firing
     while the first one's Cloudinary upload chain is still in flight. */
  var submitting = false;

  if (form) {
    /* Wave 27.4a Phase 4c — NUCLEAR REWRITE. Prior wave (Phase 4b) shipped
       a structurally-correct submit-event handler that preventDefault'd on
       line 1, yet Paul's diag proved the native POST STILL raced past our
       .then. Rather than continue instrumenting, we eliminate the whole
       class of failure: the button becomes type="button" (Liquid, this
       wave), so no user action can trigger native form submission — the
       only path to .submit() is our own click handler calling it explicitly
       from inside .then/.catch, AFTER uploads have settled.

       Three defensive layers below:
       1. Capture-phase 'submit' listener on the form as belt-and-braces:
          if ANY code, ANYWHERE, dispatches a submit event on this form,
          we intercept in the capture phase (before any bubble-phase
          listener runs) and preventDefault. Logs so we know if it fires.
       2. Keydown listener: Enter in a non-textarea input previously
          triggered browser implicit-submit — now redirected to the button
          click path, so Enter and click share the same code.
       3. Click listener on the button itself: the SOLE path to submission.
          Own guard (submitting flag), own validation, own async chain. */

    /* Capture-phase safety-net: intercept ANY submit event dispatched on
       the form before any bubble-phase listener runs. Belt-and-braces —
       the button is type="button" so nothing should trigger this, but if
       something ever does, we cancel it and force the button click path. */
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      return false;
    }, true);

    /* Enter-in-input previously triggered browser implicit-submit; redirect
       to the button click path so keyboard and mouse share the same code. */
    form.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && e.target && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        if (submitBtn) submitBtn.click();
      }
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearUploadError();

        if (submitting) return;

        /* Basic validation */
        var required = form.querySelectorAll('[required]');
        var firstInvalid = null;
        required.forEach(function(el) {
          if (!el.value.trim()) {
            el.style.borderColor = '#E08560';
            if (!firstInvalid) firstInvalid = el;
          } else {
            el.style.borderColor = '';
          }
        });
        if (firstInvalid) { firstInvalid.focus(); return; }

        submitting = true;
        submitBtn.disabled = true;
        submitBtn.classList.add('uploading');

        var uploadPromise = (uploaded.length === 0)
          ? Promise.resolve([])
          : Promise.all(uploaded.map(uploadPhoto));

        uploadPromise.then(function(urls) {
          var filtered = urls.filter(Boolean);
          if (axlePhotoUrlsField) axlePhotoUrlsField.value = filtered.join('\n');
          form.submit();
        }).catch(function() {
          /* Inline-error-and-retry: the user shouldn't silently submit with
             a broken photo upload. Show the error, re-enable the button,
             clear the submitting guard so they can retry or remove photos. */
          showUploadError('One or more photos failed to upload — please retry or remove them.');
          submitBtn.disabled = false;
          submitBtn.classList.remove('uploading');
          submitting = false;
        });
      });
    }
  }

  /* Contextual reveals inside the fit-checker */
  const axleRadios = document.querySelectorAll('input[name="axle"]');
  const reveals = document.querySelectorAll('.ctx-reveal[data-shows-for]');
  function updateReveals(){
    const checked = document.querySelector('input[name="axle"]:checked');
    const val = checked ? checked.value : '';
    reveals.forEach(el => {
      el.classList.toggle('show', el.getAttribute('data-shows-for') === val);
    });
  }
  axleRadios.forEach(r => r.addEventListener('change', updateReveals));
  updateReveals();

  /* Sticky "Ask a human" mobile pill — appears after user scrolls past the fit checker */
  const pill = document.getElementById('askPill');
  const checker = document.getElementById('finder');
  if (pill && checker){
    pill.classList.add('armed');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting && e.boundingClientRect.top < 0){
          pill.classList.add('visible');
        } else if (e.isIntersecting){
          pill.classList.remove('visible');
        }
      });
    }, { threshold: 0, rootMargin: '-30% 0px 0px 0px' });
    io.observe(checker);
  }
})();

})();
